import { createStyles, makeUiStyles, Theme } from '../../styles/styles';
import { StylesIndexInjections } from 'common-react';
import { interactiveLinkStyle, pressedLinkShadow } from '../../theme/constants';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
  },
  detailsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  topInfo: {
    marginBottom: 8,
  },
  valueBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    flex: '0 0 160px',
    flexShrink: 0,
  },
  infoBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    [theme.breakpoints.down('sm')]: {
      flexBasis: '50%',
      width: '50%',
    },
  },

  titleWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px 24px',
    width: '100%',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flex: 'auto',
      width: '100%',
      gap: 0,
    },
  },

  detailsContent: {
    display: 'flex',
    gap: 32,
    marginTop: 24,
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      gap: 0,
      marginTop: 0,
    },
  },
  titleAndIconWrapper: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 420,
    flex: '1 1 0',
    minWidth: 0,
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      flex: '1 1 100%',
    },
  },
  actionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 16,
    marginLeft: 'auto',
    width: 'auto',
    minWidth: 140,
    flex: '0 0 auto',
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      gap: 4,
      width: '100%',
      maxWidth: '100%',
      flexDirection: 'column-reverse',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  actionButtonSkeleton: {
    borderRadius: 8,
    [theme.breakpoints.down('sm')]: {
      position: 'absolute',
      width: '50%',
      maxWidth: '100%',
      padding: '11px 24px',
      height: 40,
    },
  },
  button: {
    maxWidth: 320,
    '&:hover': {
      cursor: 'pointer',
      '& $text': {
        ...interactiveLinkStyle(theme),
      },
      '& $icon path': {
        fill: theme.color.violets[100],
      },
    },
    '&:active': {
      '& $textWrapper': {
        backgroundColor: pressedLinkShadow  ,
      },
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
  selectButton: {
    '& .CircularSpinner': {
      [theme.breakpoints.down('sm')]: {
        top: 'initial'
      },
    }
  },
  noFundInfoRow: {
    color: theme.color.reds[100],
  },
  oldName: {
    display: 'block',
    color: theme.color.greys[50],
    marginBottom: 8,
    [theme.breakpoints.down('sm')]: {
      marginBottom:16,
    },
  },
  accordionTitle: {
    width: 'fit-content',
  },
  accordionExpandAction: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
      justifyContent: 'center',
      width: '100%',
    },
  },
  topBarActionsBox: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row',
      width: '100%',
    },
    [theme.breakpoints.down('xs')]: {
      alignItems: 'stretch',
      width: '100%',
      flexDirection: 'column',
    },

    '& > *:not(:last-child)': {
      marginRight: 16,
      [theme.breakpoints.down('xs')]: {
        marginRight: 0,
        marginBottom: 12,
      },
    },

    '& $ordersButton': {
      marginTop: 0,
      display: 'flex',
      alignItems: 'baseline',
      justifyContent: 'center',

      [theme.breakpoints.down('sm')]: {
        flex: 1
      },

      '& svg': {
        display: 'block'
      }
    },

    '& $actionButtonSkeleton': {
      position: 'static',
      minWidth: 100,
      [theme.breakpoints.down('xs')]: {
        flex: 1,
        width: '100%',
        maxHeight: 40,
      },
    },

    '& $selectButton': {
      width: '100%',
      position: 'static',
      padding: '15px 31px',
      [theme.breakpoints.down('sm')]: {
        padding: '11px 32px',
        flex: 1
      },
    },

    '& .MuiButtonBase-root': {
      position: 'relative',

      '& .CircularSpinner': {
        top: 19,
        [theme.breakpoints.down('sm')]: {
          top: 'initial',
        },
      }
    }
  },
  bottomBarActionsBox: {
    '& $selectButton': {
      padding: '19px 32px',
      width: '100%',
      position: 'static',
    },

    '& .MuiButtonBase-root': {
      position: 'relative',

      '& .CircularSpinner': {
        top: 19,
        [theme.breakpoints.down('sm')]: {
          top: 'initial',
        },
      }
    },
    '& $actionButtonSkeleton': {
     position: 'relative',
     height: 56,
     minWidth: 100,
     width: 100,
     borderRadius: 'unset',
    }
  },
  valueBoxesWrapper: {
    display: 'flex',
    flex: '0 0 auto',
    alignItems: 'center',
    gap: 16,
    minWidth: 320,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      gap: 8,
      '& $valueBox': {
        width: '50%',
        flex: 1
      }
    },
  },
  textWrapper: {},
  text: {},
  icon: {},
}), { name: 'FundListItemWithDetails', index: StylesIndexInjections.UI_MOLECULES });
